module.exports = __webpack_public_path__ + "4087a827d225cc9fde6140006c4bbf7d.svg";